import { render, staticRenderFns } from "./AddPriceModal.vue?vue&type=template&id=a39c0f1c"
import script from "./AddPriceModal.vue?vue&type=script&lang=js"
export * from "./AddPriceModal.vue?vue&type=script&lang=js"
import style0 from "./AddPriceModal.vue?vue&type=style&index=0&id=a39c0f1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports